import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "block w-full md:flex" }
const _hoisted_2 = { class: "flex w-full pr-s items-center" }
const _hoisted_3 = { class: "ml-s" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "text-xs" }
const _hoisted_6 = {
  key: 0,
  class: "w-full mt-s mb-m justify-start flex items-center"
}
const _hoisted_7 = {
  key: 1,
  class: "flex justify-between mt-s mb-m"
}
const _hoisted_8 = {
  key: 0,
  class: "md:flex-none w-historytag pl-s flex items-center justify-start"
}
const _hoisted_9 = { class: "w-full md:flex-none md:w-historytag flex items-center justify-center sm:justify-start" }
const _hoisted_10 = { class: "md:flex-none w-tag flex items-center justify-center" }
const _hoisted_11 = { class: "w-full md:flex-none md:w-historytag flex items-center justify-center sm:justify-start" }

import { nameFromUid } from "@/helpers/requestHelpers/publicDataRequests";
import ProfileCircle from "@/components/ProfileCircle.vue";
import { Profile } from "@/interfaces/profile";
import CoreIcon from "@/components/CoreIcon.vue";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'ChangelogEntry',
  props: {
    changeBy: {},
    changeTime: {},
    changeText: {},
    alwaysRow: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ProfileCircle, {
        profile: _ctx.changeBy ?? undefined
      }, null, 8, ["profile"]),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_unref(nameFromUid)(_ctx.changeBy?.id ?? null)), 1),
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.changeTime), 1)
      ])
    ]),
    (_ctx.$slots.custom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "custom")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.changeText != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.changeText), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["flex sm:flex-row w-full items-center", { 'flex-col': !_ctx.alwaysRow }])
          }, [
            _createElementVNode("div", _hoisted_9, [
              _renderSlot(_ctx.$slots, "from")
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(CoreIcon, {
                icon: "right",
                class: "hidden sm:block"
              }),
              _createVNode(CoreIcon, {
                icon: "down",
                class: "block sm:hidden"
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _renderSlot(_ctx.$slots, "to")
            ])
          ], 2)
        ]))
  ]))
}
}

})